import services from "../services";
import * as types from "./mutation-type";

export const ActionSetEmailRegister = ({commit}, payload) => {
    commit(types.SET_EMAIL_REGISTER, payload)
}

export const ActionSetClient = ({commit}, payload) => {
    commit(types.SET_CLIENT, payload)
}

export const setListEmployeeTypes = ({commit}, payload) => {
    commit(types.SET_LIST_EMPLOYEE_TYPES, payload)
}

export const ActionSetClientLogged = ({commit}, payload) => {
    commit(types.SET_CLIENT_LOGGED, payload)
}

export const getListEmployeeTypes = async ({_}, payload) => {
    return new Promise(async(resolve, reject) => {
        const { data } = await services.getListEmployeeTypes(payload)
        if(data.error === false) {
            resolve(data)
        }
        reject(data)
    })
}

export const ActionRegisterClient = async ({_}, payload) => {
    try {
        const response = await services.create(payload)
        const data = response.data
        return data
    } catch (error) {
        const data = error.response.data
        throw(data)
    }   
}

export const ActionGetClient = async ({dispatch}, payload) => {
    return new Promise(async(resolve, reject) => {
        const { data } = await services.get(payload)
        if(data.error === false) {
            dispatch('ActionSetClient', data.data)
            if(!data?.data?.login_approved) {
                dispatch('ActionSetClientLogged', false) 
                resolve(data)
                return;
            }
            dispatch('ActionSetClientLogged', true)            
            resolve(data)
        }
        reject(data)
    })
}

export const ActionForgotPassword = async ({_}, payload) => {
    return new Promise(async (resolve, reject) => {
        const { data } = await services.forgotPassword(payload)
        if(data.error === false) {
            resolve(data)
        }
        reject(data)
    });
}

export const ActionAuthenticate = async ({_}, payload) => {
    return new Promise(async(resolve, reject) => {
        const { data } = await services.authenticate(payload)
        if(data.error === false) {
            resolve(data)
        }
        reject(data)
    })
}

export const ActionLogout = async ({_}, payload) => {
    return new Promise(async(resolve, reject) => {
        const { data } = await services.logout(payload)
        if(data.error === false) {
            resolve(data)
        }
        reject(data)
    })
}

export const ActionAcceptTerms = async ({_}, payload) => {
    return new Promise(async(resolve, reject) => {
        const { data } = await services.acceptTerms(payload)
        if(data.error === false) {
            resolve(data)
        }
        reject(data)
    })
}

export const ActionCheckClientApproved = async ({_}, payload) => {
    return new Promise(async(resolve, reject) => {
        const { data } = await services.checkClientApproved(payload)
        if(data.error === false) {
            resolve(data)
        }
        reject(data)
    })
}